/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
import React, { useState } from "react";

import { Link, NavLink } from "react-router-dom";

import { DASHBOARD_PATH } from "Route/PathConstants";
import { Avatar, Badge, IconButton, styled } from "@mui/material";
import HelpMenuComponent from "Components/HelpMenu";
import { AssestsIcon, IconColors } from "../../Constants/AssetsConstants";
import Icon from "./CustomIcon";
import RightSideMenuComponent from "./RightSideMenu";
import ManageMetersComponent from "../ManageMeters";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -1,
    top: 5,
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "0 2px",
    backgroundColor: "#538dd5",
    color: "#fff",
  },
}));

const LogedInHeaderComponent = () => {
  const [anchorElUesr, setAnchorElUser] = React.useState(null);
  const [anchorElHelp, setAnchorElHelp] = React.useState(null);
  const [openDrawer, setopenDrawer] = useState(false);

  const [openManageMeters, setOpenManageMeters] = useState(false);

  function handleopenDrawer() {
    setopenDrawer(!openDrawer);
  }

  const handleManageMeters = () => {
    setOpenManageMeters(!openManageMeters);
    if (openManageMeters) {
      setopenDrawer(false);
    } else {
      setopenDrawer(true);
    }
  };

  const openHelp = Boolean(anchorElHelp);
  const openUser = Boolean(anchorElUesr);

  const handleClickHelp = (event) => {
    setAnchorElHelp(event.currentTarget);
  };
  const handleCloseHelp = () => {
    setAnchorElHelp(null);
  };

  const handleClickUser = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUser = () => {
    setAnchorElUser(null);
  };
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark bg-dark w-100 position-fixed"
      style={{ zIndex: 1300 }}
    >
      <div className="container-fluid">
        <div>
          <Link to="/" className="navbar-brand d-flex flex-grow-1">
            <div className="d-flex logo-header-container">
              <p className="logo-p">
                FST
                <span className="logo-p-details">design deliver empower</span>
              </p>
            </div>
          </Link>
        </div>

        <div className="me-auto mb-2 mb-lg-0" />

        <ul className="navbar-nav">
          <li className="nav-item dropdown">
            <NavLink to={DASHBOARD_PATH} className="nav-link help" onMouseEnter={handleClickHelp}>
              HELP
            </NavLink>
            <HelpMenuComponent
              open={openHelp}
              anchorEl={anchorElHelp}
              handleClose={handleCloseHelp}
            />
          </li>
          <li className="nav-item dropdown">
            <div className="vl" />
          </li>
          <li className="nav-item dropdown">
            <div style={{ height: "30px" }}>
              <StyledBadge badgeContent={4} style={{ height: "inherit" }}>
                <Icon
                  icon={AssestsIcon.ICON_NOTIFICATION}
                  size="100%"
                  color={IconColors.ICON_SKYBLUE}
                />
              </StyledBadge>
            </div>
          </li>
          <li className="nav-item dropdown">
            <div className="vl" />
          </li>
          <li className="nav-item dropdown profile-list" onClick={handleopenDrawer}>
            <span
              className="d-flex align-items-center"
              style={{ hover: "none", cursor: "pointer", fontFamily: "PoppinsMedium" }}
            >
              Bhasker
              <Avatar sx={{ width: 34, height: 34, marginLeft: 1 }} />
            </span>
            <div className="profile-menu">
              <Icon icon={AssestsIcon.ICON_MENU} size={20} />
            </div>
            <RightSideMenuComponent
              openDrawer={openDrawer}
              handleopenDrawer={handleopenDrawer}
              handleManageMeters={handleManageMeters}
              openManageMeters={openManageMeters}
            />
            <ManageMetersComponent
              openDrawer={openManageMeters}
              handleopenDrawer={handleManageMeters}
            />
          </li>
        </ul>
        <div className="nav-logo">
          <IconButton onClick={handleopenDrawer}>
            <Icon icon={AssestsIcon.ICON_MENU} size={30} />
          </IconButton>
        </div>
      </div>
    </nav>
  );
};

export default LogedInHeaderComponent;
